import {
  getAuditDetails,
  getAuditFieldInfo,
  AuditService,
  AuditActionType,
} from 'shared/userAudit/audit-constants';
import { Operation, AuditDetails } from 'data/types';
import { UtimacoPacketSwitch } from 'data/utimacoPacketSwitch/utimacoPacketSwitch.types';

// eslint-disable-next-line import/prefer-default-export
export function getAuditDetailsToSubmit(
  dialedDigitExtractionServerData: UtimacoPacketSwitch,
  originalDigitExtractionServerFormData: UtimacoPacketSwitch | null,
  isAuditEnabled: boolean,
  userId: string,
  userName: string,
  operation: Operation,
): AuditDetails {

  let actionType = AuditActionType.UTIMACO_PACKET_SWITCH_ADD;
  let isEdit = false;
  if (operation === 'UPDATE') {
    actionType = AuditActionType.UTIMACO_PACKET_SWITCH_EDIT;
    isEdit = true;
  }

  const auditDetails = getAuditDetails(
    isAuditEnabled,
    userId,
    userName,
    getAuditFieldInfo(dialedDigitExtractionServerData, null, isEdit, originalDigitExtractionServerFormData),
    dialedDigitExtractionServerData.IPADDR,
    AuditService.UTIMACO_PACKET_SWITCH,
    actionType,
  );
  return auditDetails as AuditDetails;
}
